"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[603],{

/***/ 58462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowRight3 = function SvgArrowRight3(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 14,
        viewBox: "0 0 9 7"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        d: "M4.628.616a.5.5 0 1 0-.64.768L6.203 3.23H.5a.5.5 0 0 0 0 1h5.612L3.988 6a.5.5 0 1 0 .64.769l3.23-2.693a.5.5 0 0 0 0-.768z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight3);


/***/ }),

/***/ 60696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$R": function() { return /* binding */ preventFocusOnMouseDown; },
/* harmony export */   "B3": function() { return /* binding */ setSVGTitle; },
/* harmony export */   "ef": function() { return /* binding */ getAccessibleButtonColor; },
/* harmony export */   "vR": function() { return /* binding */ generateOnKeyDownHandler; },
/* harmony export */   "yG": function() { return /* binding */ isKeyPressOnCustomControlClickEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var isKeyPressOnCustomControlClickEvent = function(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Enter" || (e === null || e === void 0 ? void 0 : e.key) === " " || (e === null || e === void 0 ? void 0 : e.key) === "Spacebar" || (e === null || e === void 0 ? void 0 : e.which) === 13 || (e === null || e === void 0 ? void 0 : e.which) === 32;
};
var generateOnKeyDownHandler = function(onClick) {
    for(var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        parameters[_key - 1] = arguments[_key];
    }
    return function(event) {
        if (isKeyPressOnCustomControlClickEvent(event)) {
            event.preventDefault();
            onClick.apply(void 0, [
                event
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(parameters)));
        }
    };
};
// the 'mousedown' event also emits 'focus' by default,
// so if we want to prevent focusing a keyboard-navigable element on click, we just need to catch that event.
var preventFocusOnMouseDown = function(event) {
    return event.preventDefault();
};
var setSVGTitle = function(containingSelector, title) {
    var specialCharactersRegex = /[^\w\s]/gi;
    var cleanSelector = containingSelector.replace(specialCharactersRegex, "");
    // bug fix:
    if (containingSelector.startsWith("#") && !cleanSelector.startsWith("#")) {
        cleanSelector = "#".concat(cleanSelector);
    }
    var element = document.querySelector("".concat(cleanSelector, " svg > title"));
    if (element === null || element === void 0 ? void 0 : element.textContent) {
        element.textContent = title;
    }
};
var ACCESSIBLE_COLOR_TRANISTIONS = {
    pink: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR
};
var getAccessibleButtonColor = function(color) {
    return ACCESSIBLE_COLOR_TRANISTIONS[color] || color;
};


/***/ }),

/***/ 16612:
/***/ (function(module) {


var URL_PREFIXES = {
    LP: "/lp/",
    FREE_TIER: "/ft/",
    SEO: "/s/",
    TEMPLATES: "/templates/",
    GO_TEMPLATES: "/go-templates/",
    TERMS: "/terms/",
    SECURITY: "/security/",
    PARTNERS: "/partners/",
    CS: "/cs/",
    INTEGRATIONS: "/integrations/",
    PODCASTS: "/pod/",
    VISION: "/vision/",
    LANG: "/lang/",
    EMAILS: "/emails/",
    HR: "/hr/",
    TEST: "/test/",
    DEVELOPERS: "/developers/",
    REFLECT: "/reflect/"
};
module.exports = {
    URL_PREFIXES: URL_PREFIXES
};


/***/ }),

/***/ 87154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ SIDE; },
/* harmony export */   "_": function() { return /* binding */ BELOW; }
/* harmony export */ });
var BELOW = "below";
var SIDE = "side";


/***/ }),

/***/ 65832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AUTO": function() { return /* binding */ AUTO; },
/* harmony export */   "BEST": function() { return /* binding */ BEST; },
/* harmony export */   "ECO": function() { return /* binding */ ECO; },
/* harmony export */   "GOOD": function() { return /* binding */ GOOD; },
/* harmony export */   "LOW": function() { return /* binding */ LOW; }
/* harmony export */ });
var AUTO = "q_auto";
var BEST = "q_auto:best";
var GOOD = "q_auto:good";
var ECO = "q_auto:eco";
var LOW = "q_auto:low";


/***/ }),

/***/ 5792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ SET_CLUSTER_FROM_PAGE_CONFIG_REASON; },
/* harmony export */   "ZD": function() { return /* binding */ PAGE_CONFIG; },
/* harmony export */   "ar": function() { return /* binding */ HP_COOKIE; },
/* harmony export */   "cv": function() { return /* binding */ SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON; },
/* harmony export */   "kh": function() { return /* binding */ PLATFORM_COOKIE; },
/* harmony export */   "sL": function() { return /* binding */ HP_SIGNUP_BUTTON; },
/* harmony export */   "xf": function() { return /* binding */ PARAM; }
/* harmony export */ });
var PARAM = "hp_param";
var PAGE_CONFIG = "hp_page_config";
var HP_COOKIE = "hp_cookie";
var PLATFORM_COOKIE = "platform_cookie";
var HP_SIGNUP_BUTTON = "hp_signup_button";
//reasons
var SET_CLUSTER_FROM_PAGE_CONFIG_REASON = "set_cluster_from_page_config";
var SET_CLUSTER_FROM_SIGNUP_BUTTON_REASON = "set_cluster_from_signup_button";


/***/ }),

/***/ 10945:
/***/ (function(module) {


var CLUSTER_TYPE = "cluster";
var USE_CASE_TYPE = "use-case";
module.exports = {
    CLUSTER_TYPE: CLUSTER_TYPE,
    USE_CASE_TYPE: USE_CASE_TYPE
};


/***/ }),

/***/ 34496:
/***/ (function(module) {

// Used for GTM

module.exports = {
    HUBSPOT_FORM_SUBMITTED: "hubspotFormSubmitted",
    IN_PAGE_AB_TEST_EVENT_NAME: "inPageAbTest",
    SHOW_COOKIEHUB_DIALOG_EVENT_NAME: "showCookiehubDialog",
    TRIGGER_COOKIEHUB_DIALOG_EVENT_NAME: "triggerCookiehubDialog",
    SIGNUP_CLICKED: "signupClicked",
    CLICK_MAIN_NAV: "click_main_nav",
    FAQ_ACCORDION: "faq_accordion",
    SIGNUP_WITH_GOOGLE_CLICKED: "signupWithGoogleClicked",
    TAG_SELECTED: "tagSelected",
    META_DATA: "meta_data"
};


/***/ }),

/***/ 50663:
/***/ (function(module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLUSTERS: function() {
        return CLUSTERS;
    },
    UTM_ADGROUP: function() {
        return UTM_ADGROUP;
    },
    UTM_BANNER: function() {
        return UTM_BANNER;
    },
    UTM_CAMPAIGN: function() {
        return UTM_CAMPAIGN;
    },
    UTM_KEYWORD: function() {
        return UTM_KEYWORD;
    },
    UTM_MEDIUM: function() {
        return UTM_MEDIUM;
    },
    UTM_SOURCE: function() {
        return UTM_SOURCE;
    },
    SIGNUP_REFERRER: function() {
        return SIGNUP_REFERRER;
    },
    LANDING_PAGE: function() {
        return LANDING_PAGE;
    }
});
var CLUSTERS = "clusters";
var UTM_ADGROUP = "utm_adgroup";
var UTM_BANNER = "utm_banner";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_KEYWORD = "utm_keyword";
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var SIGNUP_REFERRER = "signup_referrer";
var LANDING_PAGE = "landing_page";
module.exports = {
    CLUSTERS: CLUSTERS,
    UTM_ADGROUP: UTM_ADGROUP,
    UTM_BANNER: UTM_BANNER,
    UTM_CAMPAIGN: UTM_CAMPAIGN,
    UTM_KEYWORD: UTM_KEYWORD,
    UTM_MEDIUM: UTM_MEDIUM,
    UTM_SOURCE: UTM_SOURCE,
    SIGNUP_REFERRER: SIGNUP_REFERRER,
    LANDING_PAGE: LANDING_PAGE
};


/***/ }),

/***/ 54224:
/***/ (function(module) {


var CLUSTER = "cluster";
var SUB_CLUSTER = "subcluster";
var PREVENT_FREE_TIER_PARAM = "prevent_free_tier";
var SUPPORTED_OVERRIDE_QUERY_PARAMS = [
    CLUSTER,
    SUB_CLUSTER
];
var FORCE_PRICING = "force_pricing";
var FORCE_CURRENCY = "force-currency";
var DYNAMIC_ASSET_PARAM = "dimg";
var ACTIVE_TAB_ID = "ati";
var FROM_PARAM = "from";
var LOCALE = "locale";
module.exports = {
    CLUSTER: CLUSTER,
    SUB_CLUSTER: SUB_CLUSTER,
    PREVENT_FREE_TIER_PARAM: PREVENT_FREE_TIER_PARAM,
    SUPPORTED_OVERRIDE_QUERY_PARAMS: SUPPORTED_OVERRIDE_QUERY_PARAMS,
    FORCE_PRICING: FORCE_PRICING,
    FORCE_CURRENCY: FORCE_CURRENCY,
    DYNAMIC_ASSET_PARAM: DYNAMIC_ASSET_PARAM,
    ACTIVE_TAB_ID: ACTIVE_TAB_ID,
    FROM_PARAM: FROM_PARAM,
    LOCALE: LOCALE
};


/***/ }),

/***/ 77869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L4": function() { return /* binding */ XS_L; },
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "MS": function() { return /* binding */ MS; },
/* harmony export */   "Mp": function() { return /* binding */ XXS; },
/* harmony export */   "Re": function() { return /* binding */ LGR; },
/* harmony export */   "SM": function() { return /* binding */ SM; },
/* harmony export */   "T3": function() { return /* binding */ XXL; },
/* harmony export */   "XL": function() { return /* binding */ XL; },
/* harmony export */   "XS": function() { return /* binding */ XS; },
/* harmony export */   "g4": function() { return /* binding */ XS_M; },
/* harmony export */   "l$": function() { return /* binding */ XS_ML; }
/* harmony export */ });
var XXS = "xss";
var XS_M = "xs_m";
var XS_ML = "xs_ml";
var XS_L = "xs_l";
var XS = "xs";
var SM = "sm";
var MS = "ms";
var MD = "md";
var LG = "lg";
var LGR = "lgr";
var XL = "xl";
var XXL = "xxl";


/***/ }),

/***/ 698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ TABLET_QUERY_MIN_WIDTH; },
/* harmony export */   "Dp": function() { return /* binding */ MD_DESKTOP; },
/* harmony export */   "JF": function() { return /* binding */ MD_DESKTOP_WIDTH; },
/* harmony export */   "JI": function() { return /* binding */ SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH; },
/* harmony export */   "K0": function() { return /* binding */ HEADER_DESKTOP_MENU_MIN_WIDTH; },
/* harmony export */   "KI": function() { return /* binding */ FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH; },
/* harmony export */   "LG": function() { return /* binding */ LG; },
/* harmony export */   "LM": function() { return /* binding */ FOLD_TEST_MAX_WIDTH; },
/* harmony export */   "Ld": function() { return /* binding */ MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH; },
/* harmony export */   "Lk": function() { return /* binding */ MOBILE_QUERY_MIN_WIDTH; },
/* harmony export */   "M$": function() { return /* binding */ X_LARGE_SCREEN_MIN_WIDTH; },
/* harmony export */   "MD": function() { return /* binding */ MD; },
/* harmony export */   "Mp": function() { return /* binding */ XXS; },
/* harmony export */   "O$": function() { return /* binding */ MAX_DESKTOP_CONTENT_WIDTH; },
/* harmony export */   "SM": function() { return /* binding */ SM; },
/* harmony export */   "TI": function() { return /* binding */ MOBILE_QUERY_MAX_WIDTH_M; },
/* harmony export */   "W8": function() { return /* binding */ MOBILE_SMALL_PHONE_MAX_WIDTH; },
/* harmony export */   "Wh": function() { return /* binding */ MACBOOK_PRO_MAX_WIDTH; },
/* harmony export */   "XS": function() { return /* binding */ XS; },
/* harmony export */   "cb": function() { return /* binding */ SMALL_MOBILE_QUERY_MAX_WIDTH; },
/* harmony export */   "dD": function() { return /* binding */ MIN_HEADER_DESKTOP_MENU; },
/* harmony export */   "fm": function() { return /* binding */ TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY; },
/* harmony export */   "g4": function() { return /* binding */ XS_M; },
/* harmony export */   "lF": function() { return /* binding */ MOBILE_QUERY; },
/* harmony export */   "lu": function() { return /* binding */ HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH; },
/* harmony export */   "mD": function() { return /* binding */ ALTERNATE_MAC_BOOK_PRO_MAX_WIDTH_QUERY; },
/* harmony export */   "po": function() { return /* binding */ MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH; },
/* harmony export */   "sk": function() { return /* binding */ MAX_DESKTOP_GRID_WIDTH; },
/* harmony export */   "vA": function() { return /* binding */ LARGE_SCREEN_MIN_WIDTH; },
/* harmony export */   "vc": function() { return /* binding */ MID_HEADER_DESKTOP_MENU; },
/* harmony export */   "y": function() { return /* binding */ TABLET_QUERY_MAX_WIDTH; },
/* harmony export */   "zD": function() { return /* binding */ MOBILE_QUERY_MAX_WIDTH; }
/* harmony export */ });
/* unused harmony exports RETINA_RATIO_QUERY, SMALL_PHONE_BREAK, X_LG, HEADER_DESKTOP_MENU_NARROW_SCREEN, XXS_QUERY, XS_QUERY, SM_QUERY, MD_QUERY, LG_QUERY, XL_QUERY, MAC_BOOK_PRO, MOBILE_RETINA_QUERY, HEADER_DESKTOP_MENU_MID_WIDTH, TABLET_QUERY, TABLET_RETINA_QUERY */
// Retina display
var RETINA_RATIO_QUERY = "(min-device-pixel-ratio: 2)";
// Max widths
var XXS = 360;
var SMALL_PHONE_BREAK = 380; // allow 390px to be in the next level
var XS_M = 450;
var XS = 768;
var SM = 991;
var MD = 1199;
var MD_DESKTOP = 1440;
var LG = 1599;
var X_LG = 1880;
var MAX_DESKTOP_CONTENT_WIDTH = 1050;
var MAX_DESKTOP_GRID_WIDTH = 1300;
var MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH = 1440;
var FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH = 1920;
var MID_HEADER_DESKTOP_MENU = 1280;
var MIN_HEADER_DESKTOP_MENU = 1229;
var HEADER_DESKTOP_MENU_NARROW_SCREEN = 1300;
var XXS_QUERY = "(max-width: ".concat(XXS, "px)");
var XS_QUERY = "(min-width: ".concat(XXS + 1, "px) and (max-width: ").concat(XS, "px)");
var SM_QUERY = "(min-width: ".concat(XS + 1, "px) and (max-width: ").concat(SM, "px)");
var MD_QUERY = "(min-width: ".concat(SM + 1, "px) and (max-width: ").concat(MD, "px)");
var LG_QUERY = "(min-width: ".concat(MD + 1, "px) and (max-width: ").concat(LG, "px)");
var XL_QUERY = "(min-width: ".concat(LG + 1, "px)");
var MAC_BOOK_PRO = "(max-width: ".concat(MD, "px)");
var ALTERNATE_MAC_BOOK_PRO_MAX_WIDTH_QUERY = "1441px";
var MOBILE_QUERY_MAX_WIDTH = "".concat(XS, "px");
var MOBILE_SMALL_PHONE_MAX_WIDTH = "".concat(SMALL_PHONE_BREAK, "px");
var MD_DESKTOP_WIDTH = "".concat(MD_DESKTOP, "px");
var MOBILE_QUERY_MIN_WIDTH = "".concat(XS_M + 1, "px");
var MOBILE_QUERY_MAX_WIDTH_M = "".concat(XS_M, "px");
var MOBILE_QUERY = "(max-width: ".concat(MOBILE_QUERY_MAX_WIDTH, ")");
var MOBILE_RETINA_QUERY = MOBILE_QUERY + " and " + RETINA_RATIO_QUERY;
var SMALL_MOBILE_QUERY_MAX_WIDTH = "".concat(XXS, "px");
var SMALL_MOBILE_QUERY_INCLUDED_MAX_WIDTH = "".concat(XXS - 1, "px");
var TABLET_QUERY_MIN_WIDTH = "".concat(XS + 1, "px");
var TABLET_QUERY_MAX_WIDTH = "".concat(SM, "px");
var TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY = "(max-width: ".concat(SM, "px)");
var MACBOOK_PRO_MAX_WIDTH = "".concat(MD, "px");
var FOLD_TEST_MAX_WIDTH = "1270px";
var MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH = "".concat(MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, "px");
var HEADER_DESKTOP_MENU_MIN_WIDTH = "".concat(MIN_HEADER_DESKTOP_MENU, "px");
var HEADER_DESKTOP_MENU_MID_WIDTH = "".concat(MID_HEADER_DESKTOP_MENU, "px");
var HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH = "".concat(HEADER_DESKTOP_MENU_NARROW_SCREEN, "px");
var LARGE_SCREEN_MIN_WIDTH = "".concat(LG, "px");
var X_LARGE_SCREEN_MIN_WIDTH = "".concat(X_LG, "px");
var TABLET_QUERY = MD_QUERY;
var TABLET_RETINA_QUERY = TABLET_QUERY + " and " + RETINA_RATIO_QUERY;


/***/ }),

/***/ 35257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A1": function() { return /* binding */ HIDDEN; },
/* harmony export */   "AE": function() { return /* binding */ MODAL_BACKGROUND; },
/* harmony export */   "HP": function() { return /* binding */ ON_TOP_BELOW_COOKIE_BANNER; },
/* harmony export */   "KW": function() { return /* binding */ LAYER_ONE; },
/* harmony export */   "OL": function() { return /* binding */ ALWAYS_ON_TOP; },
/* harmony export */   "Pt": function() { return /* binding */ TOP_BAR_SHADOW; },
/* harmony export */   "Sj": function() { return /* binding */ LANGUAGE_PICKER_MENU; },
/* harmony export */   "U8": function() { return /* binding */ TEMPLATE_GENERATOR_ACTION_BUTTONS; },
/* harmony export */   "gR": function() { return /* binding */ SIDE_NAV; },
/* harmony export */   "jP": function() { return /* binding */ BASE_TEMPLATE_ROOT; },
/* harmony export */   "nA": function() { return /* binding */ TOP_LAYER; },
/* harmony export */   "sE": function() { return /* binding */ TOP_BAR; },
/* harmony export */   "wc": function() { return /* binding */ LAYER_TWO; },
/* harmony export */   "xE": function() { return /* binding */ ZERO; }
/* harmony export */ });
/* unused harmony exports CATEGORY, COOKIES_BANNER, CANVAS_PREVIEW, SSR_CANVAS, REACT_CANVAS */
//TODO - Maybe use layers instead
var MODAL_BACKGROUND = 999;
var SIDE_NAV = 666;
var TOP_BAR = 555;
var TOP_BAR_SHADOW = 557;
var CATEGORY = 999;
var TOP_LAYER = 9;
var ZERO = 0;
var HIDDEN = -1;
var LAYER_ONE = 100;
var LAYER_TWO = 200;
var ALWAYS_ON_TOP = 10000000;
var ON_TOP_BELOW_COOKIE_BANNER = 700000;
var COOKIES_BANNER = 1031;
var LANGUAGE_PICKER_MENU = 1032;
var BASE_TEMPLATE_ROOT = 1;
var TEMPLATE_GENERATOR_ACTION_BUTTONS = 1;
// CANVAS
var CANVAS_PREVIEW = 1;
var SSR_CANVAS = 1;
var REACT_CANVAS = (/* unused pure expression or super */ null && (-1));


/***/ }),

/***/ 24492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ withAbTests; },
/* harmony export */   "s": function() { return /* binding */ AbTestsContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var AbTestsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withAbTests = function withAbTests(WrappedComponent) {
    var AbTestsComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AbTestsComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AbTestsComponent);
        function AbTestsComponent(props) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AbTestsComponent);
            var _this;
            _this = _super.call(this, props);
            _this.getAbTestsFromValue = _this.getAbTestsFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            _this.getAbTestExactEventNameFromValue = _this.getAbTestExactEventNameFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            _this.crossOriginLocaleAbTest = _this.getCrossOriginLocaleAbTestFromValue.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this));
            return _this;
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(AbTestsComponent, [
            {
                key: "getAbTestsFromValue",
                value: function getAbTestsFromValue(value) {
                    return value && value.abTestVariants || [];
                }
            },
            {
                key: "getAbTestExactEventNameFromValue",
                value: function getAbTestExactEventNameFromValue(value) {
                    return value && value.abTestExactEventName || null;
                }
            },
            {
                key: "getCrossOriginLocaleAbTestFromValue",
                value: function getCrossOriginLocaleAbTestFromValue(value) {
                    return (value === null || value === void 0 ? void 0 : value.crossOriginLocaleAbTest) || null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AbTestsContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread_props(_object_spread({
                                ref: forwardedRef
                            }, rest), {
                                abTests: _this.getAbTestsFromValue(value),
                                abTestExactEventName: _this.getAbTestExactEventNameFromValue(value),
                                crossOriginLocaleAbTest: _this.getCrossOriginLocaleAbTestFromValue(value)
                            }));
                        }
                    });
                }
            }
        ]);
        return AbTestsComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AbTestsComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 3156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ withGenericConfig; },
/* harmony export */   "Z": function() { return /* binding */ GenericConfigContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var GenericConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withGenericConfig = function withGenericConfig(WrappedComponent) {
    var GenericConfigComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(GenericConfigComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GenericConfigComponent);
        function GenericConfigComponent(props) {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GenericConfigComponent);
            return _super.call(this, props);
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GenericConfigComponent, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenericConfigContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread({
                                ref: forwardedRef
                            }, value, rest));
                        }
                    });
                }
            }
        ]);
        return GenericConfigComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GenericConfigComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 39944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ withSegmentsData; },
/* harmony export */   "k": function() { return /* binding */ SegmentContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var SegmentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var withSegmentsData = function withSegmentsData(WrappedComponent) {
    var SegmentDataComponent = /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SegmentDataComponent, PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(SegmentDataComponent);
        function SegmentDataComponent() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, SegmentDataComponent);
            return _super.apply(this, arguments);
        }
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SegmentDataComponent, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, forwardedRef = _this_props.forwardedRef, rest = _object_without_properties(_this_props, [
                        "forwardedRef"
                    ]);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SegmentContext.Consumer, {
                        children: function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, _object_spread({
                                ref: forwardedRef
                            }, rest, value));
                        }
                    });
                }
            }
        ]);
        return SegmentDataComponent;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SegmentDataComponent, _object_spread_props(_object_spread({}, props), {
            forwardedRef: ref
        }));
    });
};


/***/ }),

/***/ 37759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_arrow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./static/svg/arrow-right-3.svg
var arrow_right_3 = __webpack_require__(58462);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.scss.js


var StyledArrowButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "enaldha0"
})("padding-left:12px;padding-right:6px;transition:", button_consts/* ARROW_TRANSITION */.NY, ";&.hover{padding-left:18px;padding-right:0px;}svg{fill:currentColor;height:12px;width:14px;}&.sm.signup{svg{width:15px;height:13px;}}&.md.signup,.lg.signup{svg{height:12px;width:16px;}}&.lg{svg{width:13px;height:11px;}}&.md{padding-left:10px;padding-right:5px;&.hover{padding-left:15px;padding-right:0px;}svg{width:12px;height:10px;}}&.xs{padding-left:8px;padding-right:4px;&.hover{padding-left:12px;padding-right:0px;}svg{width:12px;height:10px;}}&.sm{padding-left:8px;padding-right:4px;&.hover{padding-left:12px;padding-right:0px;}svg{width:10px;height:9px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.js





var ButtonArrow = function(props) {
    var size = props.size, hover = props.hover, isSignup = props.isSignup;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowButton, {
        className: classnames_default()("arrow-wrapper", size, {
            hover: hover,
            signup: isSignup
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_3/* default */.Z, {})
    });
};
ButtonArrow.defaultProps = {
    size: sizes.MD
};
/* harmony default export */ var button_arrow = (ButtonArrow);


/***/ }),

/***/ 75650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ SUBSCRIBE_BUTTON_TYPE; },
/* harmony export */   "DX": function() { return /* binding */ GET_STARTED_CONTACT_SALES_COMBO_TYPE; },
/* harmony export */   "F9": function() { return /* binding */ YOUTUBE_POPUP_LINK_TYPE; },
/* harmony export */   "Mw": function() { return /* binding */ UNDERLINE_TRANSITION; },
/* harmony export */   "NY": function() { return /* binding */ ARROW_TRANSITION; },
/* harmony export */   "Q_": function() { return /* binding */ TWO_LINK_BUTTONS_TYPE; },
/* harmony export */   "_f": function() { return /* binding */ DOWNLOAD_APP_BUTTON_TYPE; },
/* harmony export */   "ae": function() { return /* binding */ SIGNUP_COMBO_BUTTONS_TYPE; },
/* harmony export */   "ge": function() { return /* binding */ SIGNUP_BUTTON_TYPE; },
/* harmony export */   "iF": function() { return /* binding */ SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE; },
/* harmony export */   "jE": function() { return /* binding */ SECONDARY_BUTTON_TYPE; },
/* harmony export */   "xE": function() { return /* binding */ CONTACT_SALES_BUTTON_TYPE; },
/* harmony export */   "ys": function() { return /* binding */ REGULAR_BUTTON_TYPE; }
/* harmony export */ });
var REGULAR_BUTTON_TYPE = "Regular";
var SECONDARY_BUTTON_TYPE = "Secondary";
var SIGNUP_BUTTON_TYPE = "Signup";
var TWO_LINK_BUTTONS_TYPE = "ButtonsCombo";
var SIGNUP_COMBO_BUTTONS_TYPE = "SignupButtonsCombo";
var SUBSCRIBE_BUTTON_TYPE = "Subscribe";
var YOUTUBE_POPUP_LINK_TYPE = "YouTube Popup";
var SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE = "SignupAndYoutubeComboButtonsCombo";
var DOWNLOAD_APP_BUTTON_TYPE = "DownloadApp";
var CONTACT_SALES_BUTTON_TYPE = "ContactSales";
var GET_STARTED_CONTACT_SALES_COMBO_TYPE = "GetStartedContactSalesCombo";
var TRANSITION_DURATION = "0.3s";
var UNDERLINE_TRANSITION = "background-size ".concat(TRANSITION_DURATION);
var ARROW_TRANSITION = "padding ".concat(TRANSITION_DURATION, " ease-in-out");


/***/ }),

/***/ 42057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES = (__webpack_require__(72632).COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES);
var CLOUDFRONT_MOBILE_HEADER = "cloudfront-is-mobile-viewer";
var CLOUDFRONT_TABLET_HEADER = "cloudfront-is-tablet-viewer";
var CLOUDFRONT_DESKTOP_HEADER = "cloudfront-is-desktop-viewer";
var CLOUDFRONT_COUNTRY_HEADER = "cloudfront-viewer-country";
var isMobileOrTablet = function(req) {
    return isMobile(req) || isTablet(req);
};
var isMobile = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_MOBILE_HEADER] && headers[CLOUDFRONT_MOBILE_HEADER] === "true";
};
var isTablet = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_TABLET_HEADER] && headers[CLOUDFRONT_TABLET_HEADER] === "true";
};
var isDesktop = function(req) {
    var headers = req.headers;
    return headers[CLOUDFRONT_DESKTOP_HEADER] && headers[CLOUDFRONT_DESKTOP_HEADER] === "true";
};
var isCookiesPolicyRequiredCountryFromServer = function(res) {
    var cloudFrontCountry = res.getHeader(CLOUDFRONT_COUNTRY_HEADER);
    return doesCountryRequireStrictCookiePolicy(cloudFrontCountry);
};
var doesCountryRequireStrictCookiePolicy = function(cloudFrontCountry) {
    return cloudFrontCountry && COOKIES_POLICY_REQUIRED_COUNTRIES_ISO_CODES.includes(cloudFrontCountry);
};
module.exports = {
    isMobileOrTablet: isMobileOrTablet,
    isDesktop: isDesktop,
    isMobile: isMobile,
    isTablet: isTablet,
    isCookiesPolicyRequiredCountryFromServer: isCookiesPolicyRequiredCountryFromServer,
    doesCountryRequireStrictCookiePolicy: doesCountryRequireStrictCookiePolicy
};


/***/ }),

/***/ 14688:
/***/ (function(module) {


var getFileExtension = function(filename) {
    if (!filename) return null;
    if (filename.indexOf(".") < 0) return null;
    return filename.split(".").pop().toLowerCase();
};
var removeFileExtension = function(filename) {
    if (filename.indexOf(".") < 0) return filename;
    return filename.substring(0, filename.lastIndexOf("."));
};
var replaceFileExtension = function(fileName, newExtension) {
    var pos = fileName.lastIndexOf(".");
    var untilPos = pos < 0 ? fileName.length : pos;
    return fileName.substring(0, untilPos) + ".".concat(newExtension);
};
module.exports = {
    getFileExtension: getFileExtension,
    replaceFileExtension: replaceFileExtension,
    removeFileExtension: removeFileExtension
};


/***/ }),

/***/ 77784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var ref = __webpack_require__(85010), isCountryInContinent = ref.isCountryInContinent, OCEANIA = ref.OCEANIA;
var ref1 = __webpack_require__(13019), USE_OLD_STORAGE_SETTINGS = ref1.USE_OLD_STORAGE_SETTINGS, WEBSITE_AB_TEST_DEBUG_COOKIE_NAME = ref1.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME;
var getAbTestVariantNew = (__webpack_require__(41871).getAbTestVariantNew);
var doesCountryRequireStrictCookiePolicy = (__webpack_require__(42057).doesCountryRequireStrictCookiePolicy);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var ref2 = __webpack_require__(60734), SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST = ref2.SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, EXIT_POP_UP_SURVEY_AB_TEST = ref2.EXIT_POP_UP_SURVEY_AB_TEST, REVIVE_EXIT_POPUP_AB_TEST = ref2.REVIVE_EXIT_POPUP_AB_TEST, PERFORMANCE_STATIC_PAGE_AB_TEST = ref2.PERFORMANCE_STATIC_PAGE_AB_TEST, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = ref2.BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST = ref2.DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST = ref2.PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST, MOBILE_STICKY_SIGNUP_AB_TEST = ref2.MOBILE_STICKY_SIGNUP_AB_TEST, WELCOME_BACK_PAGE_TEST = ref2.WELCOME_BACK_PAGE_TEST, KEEP_REGION_TEST = ref2.KEEP_REGION_TEST, CONTACT_SALES_TYPEFORM_EMEA = ref2.CONTACT_SALES_TYPEFORM_EMEA, CONTACT_SALES_TYPEFORM_ANZ = ref2.CONTACT_SALES_TYPEFORM_ANZ, HEADER_NEW_PRODUCTS_OFFERING_TEST = ref2.HEADER_NEW_PRODUCTS_OFFERING_TEST, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST = ref2.UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST = ref2.TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST, STUDIO_IN_HEADER_TEST = ref2.STUDIO_IN_HEADER_TEST, ENHANCED_PRODUCTS_IN_HEADER_TEST = ref2.ENHANCED_PRODUCTS_IN_HEADER_TEST, WM_HIGH_INTENT_EXPERIENCE = ref2.WM_HIGH_INTENT_EXPERIENCE, CONTACT_SALES_FOOTER_TEST = ref2.CONTACT_SALES_FOOTER_TEST, CX_BOT_TEST = ref2.CX_BOT_TEST, GET_QUOTE_TEXT_IN_PRICING = ref2.GET_QUOTE_TEXT_IN_PRICING, CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD = ref2.CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD, GET_QUOTE_TEXT_AND_MODAL = ref2.GET_QUOTE_TEXT_AND_MODAL, REQUEST_DEMO_HEADER_TEST_NEW_USERS_LPS = ref2.REQUEST_DEMO_HEADER_TEST_NEW_USERS_LPS, REQUEST_DEMO_HEADER_TEST_NEW_USERS_WEBSITE_PAGES = ref2.REQUEST_DEMO_HEADER_TEST_NEW_USERS_WEBSITE_PAGES, SIGNUP_BY_PRODUCT_CAMPAIGN = ref2.SIGNUP_BY_PRODUCT_CAMPAIGN, ONE_TAP_GOOGLE_SIGNUP_CRM = ref2.ONE_TAP_GOOGLE_SIGNUP_CRM, NEW_CRM_PRICING_TEST = ref2.NEW_CRM_PRICING_TEST, CRM_PRICING_NO_BASIC_TEST = ref2.CRM_PRICING_NO_BASIC_TEST, CRM_PRICING_INCREASE_TEST = ref2.CRM_PRICING_INCREASE_TEST, REQUEST_DEMO_HEADER_TEST_PT = ref2.REQUEST_DEMO_HEADER_TEST_PT, SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST = ref2.SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST, CAMPAIGNS_IN_HEADER_TEST = ref2.CAMPAIGNS_IN_HEADER_TEST;
var trackEvent = (__webpack_require__(95470).trackEvent);
var SUNSET_BASIC_TIER_TEST_ALLOCATION = (__webpack_require__(65023).SUNSET_BASIC_TIER_TEST_ALLOCATION);
var shouldGetSkipSignUpStepInPricingAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};
var shouldSeeExitPopupSurveyAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 ? arguments[1] : void 0;
    return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};
var shouldSeeReviveExitPopupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) === REVIVE_EXIT_POPUP_AB_TEST.new_variation_name;
};
var shouldSeeStaticPagePerformanceAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
    return getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) === PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name;
};
var shouldShowBiggerStorageInPricingFeatures = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
var shouldSeeDesktopWithEnterpriseMenuAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) === DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name;
};
var shouldGetEnterpriseContactUsPageAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) === PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name;
};
var shouldGetMobileStickySignupAbTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) === MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name;
};
var shouldGetWelcomeBackPageTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], persistantCookies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, extraBigBrainParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (persistantCookies[WEBSITE_AB_TEST_DEBUG_COOKIE_NAME] === WELCOME_BACK_PAGE_TEST.test_name) return true;
    return getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) === WELCOME_BACK_PAGE_TEST.new_variation_name;
};
var shouldGetKeepRegionTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cloudfrontViewerCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var _localStorage;
        if (isRunningInClient() && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("is_in_keep_region_test")) === "true") {
            return true;
        }
        if (isCountryInContinent(cloudfrontViewerCountry, OCEANIA)) {
            // only people from Oceanic countries should enter the test
            return getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name;
        }
    } catch (error) {
    // nothing to do - just done to protect from crashes
    }
    return false;
};
var shouldGetContactSalesTypeformEmeaTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_EMEA.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_EMEA.new_variation_name;
};
var shouldGetContactSalesTypeformAnzTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_ANZ.test_name, sendBigBrainEvent) === CONTACT_SALES_TYPEFORM_ANZ.new_variation_name;
};
var shouldHaveHeaderWithNewProductsOfferingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, HEADER_NEW_PRODUCTS_OFFERING_TEST.test_name, sendBigBrainEvent) === HEADER_NEW_PRODUCTS_OFFERING_TEST.new_variation_name;
};
var shouldGetUnlimitedTimeCTATextTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.test_name, sendBigBrainEvent) === UNLIMITED_TIME_FREE_PLAN_CTA_TEXT_TEST.new_variation_name;
};
var shouldUseNewTypeformVariant = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.test_name, sendBigBrainEvent) === TYPEFORM_FIRST_SCREEN_MULTIPLE_FIELDS_TEST.new_variation_name;
};
var shouldHaveStudioProductInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, STUDIO_IN_HEADER_TEST.test_name, sendBigBrainEvent) === STUDIO_IN_HEADER_TEST.new_variation_name;
};
var shouldHaveEnhancedProductsInHeaderTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ENHANCED_PRODUCTS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === ENHANCED_PRODUCTS_IN_HEADER_TEST.new_variation_name;
};
var shouldGetWMHighIntentExperience = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, WM_HIGH_INTENT_EXPERIENCE.test_name, sendBigBrainEvent) === WM_HIGH_INTENT_EXPERIENCE.new_variation_name;
};
var shouldGetContactSalesInTheFooter = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CONTACT_SALES_FOOTER_TEST.test_name, sendBigBrainEvent) === CONTACT_SALES_FOOTER_TEST.new_variation_name;
};
var shouldGetQuoteTextInPricing = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, GET_QUOTE_TEXT_IN_PRICING.test_name, sendBigBrainEvent) === GET_QUOTE_TEXT_IN_PRICING.new_variation_name;
};
var shouldDisplayCampaignProductHomepageFirstFold = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD.test_name, sendBigBrainEvent) === CAMPAIGN_PRODUCT_HOMEPAGE_FIRST_FOLD.new_variation_name;
};
var shouldGetQuoteTextAndModal = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, GET_QUOTE_TEXT_AND_MODAL.test_name, sendBigBrainEvent) === GET_QUOTE_TEXT_AND_MODAL.new_variation_name;
};
var shouldGetSignupByProductCampaign = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, SIGNUP_BY_PRODUCT_CAMPAIGN.test_name, sendBigBrainEvent) === SIGNUP_BY_PRODUCT_CAMPAIGN.new_variation_name;
};
var shouldShowNewCrmPricingTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, NEW_CRM_PRICING_TEST.test_name, sendBigBrainEvent) === NEW_CRM_PRICING_TEST.variant_a;
};
var shouldShowCrmPricingIncreaseTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CRM_PRICING_INCREASE_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_INCREASE_TEST.new_variation_name;
};
var shouldShowCrmPricingNoBasicTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CRM_PRICING_NO_BASIC_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_NO_BASIC_TEST.variant_a;
};
var shouldSunsetBasicTierWMTest = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var testVariant = getAbTestVariantNew(abTests, SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.test_name, sendBigBrainEvent);
    trackEvent(SUNSET_BASIC_TIER_TEST_ALLOCATION, {
        data: {
            account_allocation: testVariant,
            test_name: SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.test_name,
            new_variation_name: SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.new_variation_name
        }
    });
    return testVariant === null ? null : testVariant === SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.new_variation_name;
};
var shouldShowOneTapGoogleSignupCRM = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, ONE_TAP_GOOGLE_SIGNUP_CRM.test_name, sendBigBrainEvent) === ONE_TAP_GOOGLE_SIGNUP_CRM.new_variation_name;
};
var shouldRenderRequestDemoHeaderButtonPt = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, REQUEST_DEMO_HEADER_TEST_PT.test_name, sendBigBrainEvent) === REQUEST_DEMO_HEADER_TEST_PT.new_variation_name;
};
var shouldShowCampaignsInHeader = function() {
    var abTests = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], sendBigBrainEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getAbTestVariantNew(abTests, CAMPAIGNS_IN_HEADER_TEST.test_name, sendBigBrainEvent) === CAMPAIGNS_IN_HEADER_TEST.new_variation_name;
};
module.exports = {
    shouldGetSkipSignUpStepInPricingAbTest: shouldGetSkipSignUpStepInPricingAbTest,
    shouldSeeExitPopupSurveyAbTest: shouldSeeExitPopupSurveyAbTest,
    shouldSeeReviveExitPopupAbTest: shouldSeeReviveExitPopupAbTest,
    shouldSeeStaticPagePerformanceAbTest: shouldSeeStaticPagePerformanceAbTest,
    shouldShowBiggerStorageInPricingFeatures: shouldShowBiggerStorageInPricingFeatures,
    shouldSeeDesktopWithEnterpriseMenuAbTest: shouldSeeDesktopWithEnterpriseMenuAbTest,
    shouldGetEnterpriseContactUsPageAbTest: shouldGetEnterpriseContactUsPageAbTest,
    shouldGetMobileStickySignupAbTest: shouldGetMobileStickySignupAbTest,
    shouldGetWelcomeBackPageTest: shouldGetWelcomeBackPageTest,
    shouldGetKeepRegionTest: shouldGetKeepRegionTest,
    shouldGetContactSalesTypeformEmeaTest: shouldGetContactSalesTypeformEmeaTest,
    shouldGetContactSalesTypeformAnzTest: shouldGetContactSalesTypeformAnzTest,
    shouldHaveHeaderWithNewProductsOfferingTest: shouldHaveHeaderWithNewProductsOfferingTest,
    shouldGetUnlimitedTimeCTATextTest: shouldGetUnlimitedTimeCTATextTest,
    shouldUseNewTypeformVariant: shouldUseNewTypeformVariant,
    shouldHaveStudioProductInHeaderTest: shouldHaveStudioProductInHeaderTest,
    shouldHaveEnhancedProductsInHeaderTest: shouldHaveEnhancedProductsInHeaderTest,
    shouldGetWMHighIntentExperience: shouldGetWMHighIntentExperience,
    shouldGetContactSalesInTheFooter: shouldGetContactSalesInTheFooter,
    shouldGetQuoteTextInPricing: shouldGetQuoteTextInPricing,
    shouldDisplayCampaignProductHomepageFirstFold: shouldDisplayCampaignProductHomepageFirstFold,
    shouldGetQuoteTextAndModal: shouldGetQuoteTextAndModal,
    shouldGetSignupByProductCampaign: shouldGetSignupByProductCampaign,
    shouldShowNewCrmPricingTest: shouldShowNewCrmPricingTest,
    shouldShowCrmPricingNoBasicTest: shouldShowCrmPricingNoBasicTest,
    shouldSunsetBasicTierWMTest: shouldSunsetBasicTierWMTest,
    shouldShowOneTapGoogleSignupCRM: shouldShowOneTapGoogleSignupCRM,
    shouldRenderRequestDemoHeaderButtonPt: shouldRenderRequestDemoHeaderButtonPt,
    shouldShowCampaignsInHeader: shouldShowCampaignsInHeader,
    shouldShowCrmPricingIncreaseTest: shouldShowCrmPricingIncreaseTest
};


/***/ }),

/***/ 90958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Is": function() { return /* binding */ getClustersConfig; },
/* harmony export */   "PH": function() { return /* binding */ setClusterForUser; },
/* harmony export */   "aC": function() { return /* binding */ updateUserClustersListWithMultipleClusters; },
/* harmony export */   "cd": function() { return /* binding */ parsePageLoadClusters; },
/* harmony export */   "jw": function() { return /* binding */ getProductByClustersIds; },
/* harmony export */   "lR": function() { return /* binding */ updateUserClustersListWithSingleCluster; },
/* harmony export */   "lc": function() { return /* binding */ setClusterIdIfNeeded; }
/* harmony export */ });
/* unused harmony exports getCurrentClusters, getClusterIdsFromLastTagsSelection */
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10092);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67798);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95470);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65023);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50663);
/* harmony import */ var _constants_localstorage__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54224);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_constants_query_params__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5792);
/* harmony import */ var _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10945);
/* harmony import */ var _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mondaydotcomorg_clusters_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38542);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73645);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84074);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20618);
/* harmony import */ var services_utils_service_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_11__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
















var MAX_CLUSTERS = 10;
var DEFAULT_HOMEPAGE_SOURCE = "na_hp";
var OPERATIONS = {
    ADDED: "added",
    UPDATED: "updated",
    NOTHING: "nothing",
    ADDED_AND_REMOVED: "added_and_removed"
};
//* *********************************  LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// Keeping support for old utm_cluster_id and utm_sub_cluster_id_cookies - will become obsolete eventually - Platform and Bigrain will use only data points
var setFinalClusterIdAndTrackEventIfNeeded = function(clusterId, reason, options) {
    (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.CLUSTER_COOKIE, clusterId);
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.setUtmClusterId)(clusterId);
    if (options.sendBigBrainEvent) {
        (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_CLUSTER_ID_EVENT_NAME, {
            kind: clusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setFinalSubClusterIdAndTrackEventIfNeeded = function(subClusterId, reason, options) {
    if (subClusterId) {
        (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .setCookie */ .d8)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE, subClusterId);
    }
    if (!subClusterId && (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE)) {
        //	removing the cookie so we won't have sub cluster of another cluster
        (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_0__/* .removeCookie */ .nJ)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.SUB_CLUSTER_COOKIE);
    }
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.setUtmSubClusterId)(subClusterId);
    if (options.sendBigBrainEvent) {
        (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_SUB_CLUSTER_ID_EVENT_NAME, {
            kind: subClusterId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setClusterIdIfNeeded = function(configClusterId, subClusterId) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var clusterReason = options.reason || _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .SET_CLUSTER_FROM_PAGE_CONFIG_REASON */ .Dj;
    if (configClusterId) {
        setFinalClusterIdAndTrackEventIfNeeded(configClusterId, clusterReason, options);
        setFinalSubClusterIdAndTrackEventIfNeeded(subClusterId, clusterReason, options); //	setting if having, or clearing if not
    }
};
//* ********************************* END OF LEGACY UTM CLUSTER AND SUBCLUSTER COOKIE SUPPORT  *************************************************************** */
// ---------------------------------------------- //
// -----  MULTIPLE CLUSTERS ON LOCAL STORAGE ---- //
// ---------------------------------------------- //
var shouldSetClusterToUser = function(source) {
    //  if the source is cookie, we won't log, as it was logged already
    return ![
        _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .HP_COOKIE */ .ar,
        _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh
    ].includes(source);
};
var setClusterForUser = function(clusterId, clusterType, clusterSource) {
    var clusterExtraData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    //  todo: should move the utm_cluster_id logic into here
    //   and have a "black box" which will set the "right" cluster cookie for the user,
    //   which will be used on the next page load as default value (see getClusterValueAndSource)
    if (clusterId && shouldSetClusterToUser(clusterSource)) {
        updateUserClustersListWithSingleCluster(clusterId, clusterType, clusterSource, {
            clusterExtraData: clusterExtraData
        });
    }
};
// TODO: ASK Etay - can we keep this functions as is with the subCluster param etc.. ? there is a lot of code depending on it.
var getClusterInfoForCurrentSession = function(overrideParams, cookies, pageConfig, options) {
    // for making things simpler for now, subclusters must have cluster with them (in param/page config/etc...)
    var clusterId, subClusterId, clusterIdSource, subClusterIdSource;
    var isPricingPage = options.pricingPage; // platform cookies is relevant only for pricing page, and pricing page doesn't use page config
    if (overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.CLUSTER]) {
        clusterId = overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.CLUSTER];
        subClusterId = overrideParams[_constants_query_params__WEBPACK_IMPORTED_MODULE_4__.SUB_CLUSTER];
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PARAM */ .xf;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PARAM */ .xf;
    } else if (isPricingPage && cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_CLUSTER_COOKIE]) {
        clusterId = cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_CLUSTER_COOKIE];
        subClusterId = cookies[_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.PLATFORM_ACCOUNT_SUB_CLUSTER_COOKIE];
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PLATFORM_COOKIE */ .kh;
    } else if (!isPricingPage && pageConfig.clusterId) {
        clusterId = pageConfig.clusterId;
        subClusterId = pageConfig.subClusterId;
        clusterIdSource = _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
    } else {
        clusterId = pageConfig.clusterId;
        subClusterId = pageConfig.subClusterId;
        clusterIdSource = undefined;
        subClusterIdSource = subClusterId && _constants_clusters_sources__WEBPACK_IMPORTED_MODULE_13__/* .PAGE_CONFIG */ .ZD;
    }
    return {
        clusterId: clusterId,
        subClusterId: subClusterId,
        clusterIdSource: clusterIdSource,
        subClusterIdSource: subClusterIdSource
    };
};
var parsePageLoadClusters = function(overrideParams, cookies, pageConfig) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return getClusterInfoForCurrentSession(overrideParams, cookies, pageConfig, options);
};
var createCluster = function(param) {
    var clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, _source = param.source, source = _source === void 0 ? DEFAULT_HOMEPAGE_SOURCE : _source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    return _object_spread({
        cluster_id: clusterId,
        type: clusterType,
        source: source,
        attribution_time: attributionTime,
        last_seen: attributionTime
    }, extraData);
};
var getIndexOfClusterIfExists = function(clustersOfUser, newCluster) {
    var indexOfClusterIfExists = null;
    clustersOfUser.some(function(e, index) {
        if (e.cluster_id === newCluster.cluster_id && e.type === newCluster.type && e.source === newCluster.source) {
            indexOfClusterIfExists = index;
            return true;
        }
    });
    return indexOfClusterIfExists;
};
var addOrUpdateClustersIfNeeded = function(param) {
    var clustersOfUser = param.clustersOfUser, newCluster = param.newCluster, attributionTime = param.attributionTime;
    var indexOfClusterIfExists = getIndexOfClusterIfExists(clustersOfUser, newCluster);
    if (indexOfClusterIfExists !== null) {
        clustersOfUser[indexOfClusterIfExists].last_seen = attributionTime;
        return OPERATIONS.UPDATED;
    }
    clustersOfUser.push(newCluster);
    if (clustersOfUser.length > MAX_CLUSTERS) {
        // removeOldestEntry(clustersOfUser); // following up first
        return OPERATIONS.ADDED_AND_REMOVED;
    }
    return OPERATIONS.ADDED;
};
var getCurrentClusters = function() {
    try {
        return JSON.parse(localStorage.getItem(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__.CLUSTERS)) || [];
    } catch (e) {
        return [];
    }
};
var saveClusters = function(clustersOfUser) {
    localStorage.setItem(_constants_localstorage__WEBPACK_IMPORTED_MODULE_3__.CLUSTERS, JSON.stringify(clustersOfUser));
};
var updateCluster = function(param) {
    var clustersOfUser = param.clustersOfUser, clusterId = param.clusterId, clusterType = param.clusterType, attributionTime = param.attributionTime, source = param.source, _extraData = param.extraData, extraData = _extraData === void 0 ? {} : _extraData;
    if (!clusterId) return;
    var newCluster = createCluster({
        clusterId: clusterId,
        clusterType: clusterType,
        attributionTime: attributionTime,
        source: source,
        extraData: extraData
    });
    var operationStatus = addOrUpdateClustersIfNeeded({
        clustersOfUser: clustersOfUser,
        newCluster: newCluster,
        attributionTime: attributionTime
    });
    (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.SET_CLUSTER_EVENT, {
        kind: operationStatus,
        info1: clusterId,
        info2: clusterType,
        info3: location.href,
        placement: source,
        data: JSON.stringify(extraData)
    });
};
var updateUserClustersListWithMultipleClusters = function(clusters, source) {
    var clustersOfUser = getCurrentClusters();
    var attributionTime = new Date().getTime();
    clusters.forEach(function(cluster) {
        var clusterId = cluster.clusterId, clusterType = cluster.clusterType, extraData = cluster.extraData;
        updateCluster({
            clustersOfUser: clustersOfUser,
            clusterId: clusterId,
            clusterType: clusterType,
            attributionTime: attributionTime,
            source: source,
            extraData: extraData
        });
    });
    saveClusters(clustersOfUser);
};
var updateUserClustersListWithSingleCluster = function(clusterId, clusterType, source) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var clusterExtraData = options.clusterExtraData, setSignupCluster = options.setSignupCluster, useCaseId = options.useCaseId, restOptions = _object_without_properties(options, [
        "clusterExtraData",
        "setSignupCluster",
        "useCaseId"
    ]);
    var clusters = [
        {
            clusterId: clusterId,
            clusterType: clusterType,
            extraData: clusterExtraData
        }
    ];
    if (useCaseId) {
        clusters.push({
            clusterId: useCaseId,
            clusterType: _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__.USE_CASE_TYPE,
            extraData: _object_spread_props(_object_spread({}, clusterExtraData), {
                parent_cluster_id: clusterId
            })
        });
    }
    updateUserClustersListWithMultipleClusters(clusters, source);
    if (clusterType === _constants_clusters_types_js__WEBPACK_IMPORTED_MODULE_5__.CLUSTER_TYPE && setSignupCluster) {
        setClusterIdIfNeeded(clusterId, useCaseId, restOptions);
    }
};
var getClustersConfig = function() {
    var _ref = _async_to_generator(function(clusterId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            return [
                2,
                _mondaydotcomorg_clusters_service__WEBPACK_IMPORTED_MODULE_6__/* .HOMEPAGE_CLUSTERS_DATA */ .r[clusterId]
            ];
        });
    });
    return function getClustersConfig(clusterId) {
        return _ref.apply(this, arguments);
    };
}();
var getClusterIdsFromLastTagsSelection = function(clusters) {
    var clustersFromTags = clusters.filter(function(cluster) {
        return cluster.source === HP_TAGS_SELECTION;
    });
    var lastAttributedCluster = orderBy(clustersFromTags, [
        "last_seen"
    ], [
        "desc"
    ])[0];
    var lastAttributedClusters = clustersFromTags.filter(function(cluster) {
        return cluster.last_seen === lastAttributedCluster.last_seen;
    });
    return lastAttributedClusters.map(function(cluster) {
        return cluster.cluster_id;
    });
};
var getProductByClustersIds = function(clustersIds) {
    // no selection or 'More workflows' is selected ('More workflows' is not assigned with a cluster)
    if (clustersIds.length === 0) {
        return null;
    }
    // all clusters that do not exist in the map, map to work management
    var productsIds = (0,services_utils_service_js__WEBPACK_IMPORTED_MODULE_10__.newUniqueArray)(clustersIds.map(function(clusterId) {
        return constants_products__WEBPACK_IMPORTED_MODULE_8__/* .clusterIdToProductIdMap */ .xr[clusterId] || constants_products__WEBPACK_IMPORTED_MODULE_8__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py;
    }));
    // selection maps to a single product
    if (productsIds.length === 1) {
        return productsIds[0];
    }
    // selection maps to multiple products - return 'Work management'
    return constants_products__WEBPACK_IMPORTED_MODULE_8__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py;
};


/***/ }),

/***/ 40927:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var _cloudinaryAssetQualities = __webpack_require__(65832);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var SHA256 = __webpack_require__(52153);
var CLOUDINARY_CLOUD_NAME = "dapulse";
var CLOUDINARY_BASE = "https://dapulse-res.cloudinary.com/";
var CLOUDINARY_UNSECURE_BASE = "http://dapulse-res.cloudinary.com/";
var CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var CLOUDINARY_IMAGE_DIRECTORY = "image/";
var CLOUDINARY_VIDEO_DIRECTORY = "video/";
var CLOUDINARY_STATIC_FOLDER_NAME = "/static";
var GENERATOR_FEATURED_IMAGES_FOLDER = "Generator_featured images";
var CLOUDINARY_MEDIA_LIBRARY_USER_NAME = "eranh@monday.com";
var CLOUDINARY_MEDIA_LIBRARY_SCRIPT = "https://media-library.cloudinary.com/global/all.js";
var CLOUDINARY_BASE_VIDEO_URL = "".concat(CLOUDINARY_STATIC_FOLDER, "/video/video-library");
var CLOUDINARY_VIDEO_RESOURCE = "video";
var CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER = "".concat(CLOUDINARY_STATIC_FOLDER, "/uploads");
var CLOUDINARY_IMAGE_RESOURCE = "image";
var CLOUDINARY_IMAGE_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_IMAGE_DIRECTORY);
var CLOUDINARY_VIDEO_PREFIX = "".concat(CLOUDINARY_BASE).concat(CLOUDINARY_VIDEO_DIRECTORY);
var LOW_RES_IMAGE_QUALITY_LEVEL = 1;
var IMAGE_DEFAULT_BLUR = 300;
var CLOUDINARY_IMAGE_FILE_TYPE = "IMAGE";
var CLOUDINARY_VIDEO_FILE_TYPE = "VIDEO";
var CLOUDINARY_GIF_FILE_TYPE = "GIF";
var CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE = "VIDEO_THUMBNAIL";
var GIF_FILE_EXTENSION = "gif";
var JPG_FILE_EXTENSION = "jpg";
var GIF_TO_VIDEO_AUTO_TRANSFORMATION = "f_mp4,f_auto";
var VIDEO_THUMBNAIL_TRANSFORMATION = "so_0p";
var FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM = "d";
var addBasePathToUrl = (__webpack_require__(932).addBasePathToUrl);
var ref = __webpack_require__(14688), getFileExtension = ref.getFileExtension, replaceFileExtension = ref.replaceFileExtension;
var PRODUCTION_CLOUDINARY_STATIC_FOLDER = "remote_mondaycom_static";
var STAGING_CLOUDINARY_STATIC_FOLDER = "remote_mondaystagingcom_static";
// Holds auto upload mappings configured in cloudinary account for use to migrate images to cloudinary from s3 buckets
var AutoUploadMappings = {
    "https://monday.com/static": PRODUCTION_CLOUDINARY_STATIC_FOLDER,
    "https://monday.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/Generator_featured images": GENERATOR_FEATURED_IMAGES_FOLDER,
    "https://mondaystaging.com/static": STAGING_CLOUDINARY_STATIC_FOLDER
};
var AutoUploadMappingsKeys = Object.keys(AutoUploadMappings);
var defaultTransformationParams = {
    crop: "fill",
    gravity: "faces"
};
// For creating the url
var PresetKeysConvertion = {
    width: "w_",
    height: "h_",
    crop: "c_",
    gravity: "g_",
    aspectRatio: "ar_",
    radius: "r_",
    quality: "q_",
    blur: "e_blur:",
    raw: "raw",
    defaultImage: "d_"
};
var PresetKeysConvertionKey = Object.keys(PresetKeysConvertion);
// These presets are pre made by cloudinary and does not require any additional calculation (on-the-fly calculations)
// If changed - make sure to update the upload presets (both production and staging) in cloudinary account
var PresetTransformations = {
    SMALL_CARD: _object_spread({
        width: 328,
        height: 225
    }, defaultTransformationParams),
    FEATURE_CARD: _object_spread({
        aspectRatio: "704:410",
        width: 704,
        height: 410
    }, defaultTransformationParams),
    SMALL: _object_spread({
        width: 128
    }, defaultTransformationParams),
    MEDUIM: _object_spread({
        width: 256
    }, defaultTransformationParams),
    LARGE: _object_spread({
        width: 512
    }, defaultTransformationParams),
    XLARGE: _object_spread({
        width: 1024
    }, defaultTransformationParams),
    XXLARGE: _object_spread({
        width: 2048
    }, defaultTransformationParams),
    SMALL_ROUND: _object_spread({
        radius: "max",
        width: 128,
        height: 128
    }, defaultTransformationParams),
    TEMPLATE_COVER: _object_spread({
        aspectRatio: "1766:768"
    }, defaultTransformationParams)
};
var extractPublicId = function(src) {
    if (!src) {
        return {
            publicId: src
        };
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // checking if src is mapped in cloudinary for auto upload
        for(var _iterator = AutoUploadMappingsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (src.startsWith(key)) {
                // this url is for auto upload
                var id = src.substring(key.length);
                var newUrl = "".concat(AutoUploadMappings[key]).concat(id);
                return {
                    publicId: newUrl
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        isFetch: true,
        publicId: src
    }; // other urls that are not auto uploaded
};
var getCloudinaryMethodPostfix = function(isFetch) {
    return isFetch ? "fetch/" : "upload/";
};
var generateCloudinaryRawUrl = function(src) {
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var postfix = getCloudinaryMethodPostfix(isFetch);
    return "".concat(CLOUDINARY_BASE, "raw/").concat(postfix).concat(publicId);
};
var getPrefix = function(fileType) {
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
        case CLOUDINARY_GIF_FILE_TYPE:
            return CLOUDINARY_IMAGE_PREFIX;
        case CLOUDINARY_VIDEO_FILE_TYPE:
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return CLOUDINARY_VIDEO_PREFIX;
        default:
            return CLOUDINARY_IMAGE_PREFIX;
    }
};
var getImageTransformation = function(assetQuality) {
    return "f_auto,".concat(assetQuality);
};
var getVideoTransformation = function(assetQuality) {
    return "".concat(assetQuality, ",f_auto,cs_copy");
}; // reversed the order to clear cache with monday 2.0 video issue
var getTransformation = function(param) {
    var fileType = param.fileType, assetQuality = param.assetQuality;
    assetQuality = assetQuality || _cloudinaryAssetQualities.AUTO;
    switch(fileType){
        case CLOUDINARY_IMAGE_FILE_TYPE:
            return getImageTransformation(assetQuality);
        case CLOUDINARY_VIDEO_FILE_TYPE:
            return getVideoTransformation(assetQuality);
        case CLOUDINARY_GIF_FILE_TYPE:
            return GIF_TO_VIDEO_AUTO_TRANSFORMATION;
        case CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE:
            return VIDEO_THUMBNAIL_TRANSFORMATION;
        default:
            return getImageTransformation(assetQuality);
    }
};
var getPresets = function(transformation, preset) {
    if (!preset) return transformation;
    var transformations = [
        transformation
    ];
    PresetKeysConvertionKey.forEach(function(key) {
        if (preset[key]) {
            transformations.push("".concat(PresetKeysConvertion[key]).concat(preset[key]));
        }
    });
    return transformations.join(",");
};
var generateCloudinaryUrl = function(fileType, publicId, isFetch, preset) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var assetQuality = options.assetQuality;
    var prefix = getPrefix(fileType);
    var postfix = getCloudinaryMethodPostfix(isFetch);
    var transformation = getTransformation({
        fileType: fileType,
        assetQuality: assetQuality
    });
    var presets = getPresets(transformation, preset);
    var cloudinaryUrl = "".concat(prefix).concat(postfix).concat(presets, "/").concat(publicId);
    return cloudinaryUrl;
};
var extractWidthTransformationIfNeeded = function(props, cloudinaryTransformations) {
    var width = props.width;
    if (!width) return cloudinaryTransformations;
    if (typeof width === "number") {
        cloudinaryTransformations.width = width;
    } else if (typeof width === "string" && width.indexOf("px") > -1) {
        cloudinaryTransformations.width = parseInt(width);
    }
    return cloudinaryTransformations;
};
var extractCloudinaryTransformations = function() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cloudinaryTransformations = {};
    cloudinaryTransformations = extractWidthTransformationIfNeeded(props, cloudinaryTransformations);
    return cloudinaryTransformations;
};
var generateCloudinaryImageUrl = function(src) {
    var cloudinaryTransformations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_IMAGE_FILE_TYPE, publicId, isFetch, cloudinaryTransformations, options);
};
var getCloudinaryUrlSrc = function(src) {
    return isCloudinaryUrl(src) ? src : generateCloudinaryImageUrl(src);
};
var generateCloudinaryVideoThumbnail = function(videoSrc) {
    var fixedSrc = addBasePathToUrl(videoSrc);
    var fileWithImageExtension = replaceFileExtension(fixedSrc, JPG_FILE_EXTENSION);
    var ref = extractPublicId(fileWithImageExtension), isFetch = ref.isFetch, publicId = ref.publicId;
    return generateCloudinaryUrl(CLOUDINARY_VIDEO_THUMBNAIL_FILE_TYPE, publicId, isFetch, null);
};
var generateCloudinaryVideoThumbnailFromFullUrl = function(fullVideoUrl) {
    var urlWithTransformation = fullVideoUrl.replace("/video/upload/", "/video/upload/so_0p/");
    return urlWithTransformation.replace(/\.[^.]+$/, ".".concat(JPG_FILE_EXTENSION));
};
var generateCloudinaryVideoUrl = function(src) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fixedSrc = addBasePathToUrl(src);
    var ref = extractPublicId(fixedSrc), isFetch = ref.isFetch, publicId = ref.publicId;
    var fileType = getFileExtension(src) === GIF_FILE_EXTENSION ? CLOUDINARY_GIF_FILE_TYPE : CLOUDINARY_VIDEO_FILE_TYPE;
    return generateCloudinaryUrl(fileType, publicId, isFetch, null, options);
};
var getPropValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl);
    var staticFolderPrefix = cloudinaryDecodedUrl.indexOf(CLOUDINARY_STATIC_FOLDER);
    if (staticFolderPrefix > -1) {
        var splitStr = cloudinaryDecodedUrl.substring(staticFolderPrefix + CLOUDINARY_STATIC_FOLDER.length);
        return "".concat(CLOUDINARY_STATIC_FOLDER_NAME).concat(splitStr);
    }
    var featuredImagesFolderPrefix = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    if (featuredImagesFolderPrefix > -1) {
        return "/".concat(cloudinaryDecodedUrl.substring(featuredImagesFolderPrefix));
    }
    return cloudinaryFullUrl;
};
var getFolderValueFromCloudinaryUrl = function(cloudinaryFullUrl) {
    if (!cloudinaryFullUrl) return;
    var cloudinaryDecodedUrl = decodeURIComponent(cloudinaryFullUrl).replace("http:", "https:");
    var prefixUrl = "".concat(CLOUDINARY_BASE, "image/upload/");
    var relativeUrl = cloudinaryDecodedUrl.indexOf(prefixUrl);
    if (relativeUrl > -1) {
        var relativeFolder = cloudinaryDecodedUrl.substring(prefixUrl.length, cloudinaryDecodedUrl.lastIndexOf("/"));
        return relativeFolder.substring(relativeFolder.indexOf("/") + 1, relativeFolder.length); // remove the v[number] folder path
    }
    return null;
};
var getCloudinaryMediaLibraryAuthenticationAccess = function() {
    var _ref = _async_to_generator(function() {
        var get, ref, CLOUDINARY_API_KEY, CLOUDINARY_API_SECRET, timeStamp, userName, authString, signature, apiKey;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    get = (__webpack_require__(61217).get);
                    return [
                        4,
                        get("cloudinary")
                    ];
                case 1:
                    ref = _state.sent(), CLOUDINARY_API_KEY = ref.api_key, CLOUDINARY_API_SECRET = ref.api_secret;
                    timeStamp = Math.round(new Date().getTime() / 1000);
                    userName = CLOUDINARY_MEDIA_LIBRARY_USER_NAME;
                    authString = "cloud_name=".concat(CLOUDINARY_CLOUD_NAME, "&timestamp=").concat(timeStamp, "&username=").concat(userName).concat(CLOUDINARY_API_SECRET);
                    signature = SHA256(authString).toString();
                    apiKey = CLOUDINARY_API_KEY;
                    return [
                        2,
                        {
                            timeStamp: timeStamp,
                            signature: signature,
                            userName: userName,
                            apiKey: apiKey
                        }
                    ];
            }
        });
    });
    return function getCloudinaryMediaLibraryAuthenticationAccess() {
        return _ref.apply(this, arguments);
    };
}();
var getMediaLibraryCreationConfig = function(cloudinaryAuthentication) {
    return {
        cloud_name: CLOUDINARY_CLOUD_NAME,
        api_key: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.apiKey,
        username: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.userName,
        insert_caption: "Select",
        timestamp: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.timeStamp,
        signature: cloudinaryAuthentication === null || cloudinaryAuthentication === void 0 ? void 0 : cloudinaryAuthentication.signature,
        multiple: false
    };
};
var isCloudinaryUrl = function(url) {
    return (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_BASE)) === 0 || (url === null || url === void 0 ? void 0 : url.indexOf(CLOUDINARY_UNSECURE_BASE)) === 0;
};
var getColorTransformation = function(color) {
    if (!color) return null;
    // if color doesn't start with a pound sign (although should) -
    // return an empty string that would not affect the Cloudinary url
    if (color.charAt(0) !== "#") {
        return null;
    }
    // remove pound sound from color
    var colorWithNoPoundSign = color.substring(1);
    return "e_colorize,co_rgb:".concat(colorWithNoPoundSign, "/");
};
/* DON'T USE THIS FUNCTION
 * It's currently used for a specific use case, and will be fixed later so it can be used by any component
 * */ var getUrlWithColor = function(param) {
    var url = param.url, color = param.color;
    var cloudinaryDecodedUrl = decodeURIComponent(url);
    var colorString = getColorTransformation(color);
    // if failed to create the color transformation
    if (!colorString) {
        return url;
    }
    var insertPosition = cloudinaryDecodedUrl.indexOf(GENERATOR_FEATURED_IMAGES_FOLDER);
    var urlWithColor = [
        cloudinaryDecodedUrl.slice(0, insertPosition),
        colorString,
        cloudinaryDecodedUrl.slice(insertPosition)
    ].join("");
    return urlWithColor;
};
module.exports = {
    CLOUDINARY_CLOUD_NAME: CLOUDINARY_CLOUD_NAME,
    LOW_RES_IMAGE_QUALITY_LEVEL: LOW_RES_IMAGE_QUALITY_LEVEL,
    IMAGE_DEFAULT_BLUR: IMAGE_DEFAULT_BLUR,
    CLOUDINARY_IMAGE_FILE_TYPE: CLOUDINARY_IMAGE_FILE_TYPE,
    PresetTransformations: PresetTransformations,
    extractPublicId: extractPublicId,
    generateCloudinaryUrl: generateCloudinaryUrl,
    generateCloudinaryImageUrl: generateCloudinaryImageUrl,
    generateCloudinaryVideoUrl: generateCloudinaryVideoUrl,
    generateCloudinaryRawUrl: generateCloudinaryRawUrl,
    generateCloudinaryVideoThumbnail: generateCloudinaryVideoThumbnail,
    extractCloudinaryTransformations: extractCloudinaryTransformations,
    CLOUDINARY_STATIC_FOLDER: CLOUDINARY_STATIC_FOLDER,
    CLOUDINARY_BASE_VIDEO_URL: CLOUDINARY_BASE_VIDEO_URL,
    CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER: CLOUDINARY_IMAGE_UPLOADS_BASE_FOLDER,
    getPropValueFromCloudinaryUrl: getPropValueFromCloudinaryUrl,
    getFolderValueFromCloudinaryUrl: getFolderValueFromCloudinaryUrl,
    getCloudinaryMediaLibraryAuthenticationAccess: getCloudinaryMediaLibraryAuthenticationAccess,
    CLOUDINARY_MEDIA_LIBRARY_SCRIPT: CLOUDINARY_MEDIA_LIBRARY_SCRIPT,
    CLOUDINARY_VIDEO_RESOURCE: CLOUDINARY_VIDEO_RESOURCE,
    CLOUDINARY_IMAGE_RESOURCE: CLOUDINARY_IMAGE_RESOURCE,
    getMediaLibraryCreationConfig: getMediaLibraryCreationConfig,
    isCloudinaryUrl: isCloudinaryUrl,
    CLOUDINARY_IMAGE_PREFIX: CLOUDINARY_IMAGE_PREFIX,
    FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM: FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM,
    getCloudinaryUrlSrc: getCloudinaryUrlSrc,
    getUrlWithColor: getUrlWithColor,
    generateCloudinaryVideoThumbnailFromFullUrl: generateCloudinaryVideoThumbnailFromFullUrl
};


/***/ }),

/***/ 932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);

var COMMUNITY_URL_PREFIX = "";
var isDevelopment = process.env.ENV == "DEV";
var MONDAY_STORIES_SLUG_URL = "https://mondaystories.monday.com";
var getTemplateUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/show/").concat(templateId);
};
var getTemplateUrlWithNextTemplates = function(templateId, nextTemplatesIds) {
    if (!templateId) {
        return null;
    }
    if (!nextTemplatesIds || nextTemplatesIds.length == 0) {
        return getTemplateUrl(templateId);
    }
    return "".concat(getTemplateUrl(templateId), "?next=").concat(nextTemplatesIds.join());
};
var getTemplateEditUrl = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit/").concat(templateId);
};
var getTemplateEditSelfie = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-selfie/").concat(templateId);
};
var getTemplateEditBoardScreenshot = function(templateId) {
    if (!templateId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/edit-board-screenshot/").concat(templateId);
};
var getUserTemplatesUrl = function(userId) {
    if (!userId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/user/").concat(userId);
};
var getAccountTemplatesUrl = function(accountId) {
    if (!accountId) {
        return null;
    }
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/account/").concat(accountId);
};
var getAdminPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/admin");
};
var getTop5CategoryPageUrl = function(category) {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/top5/").concat(category);
};
var getShareNewTemplateUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/templates/new");
};
var getUserPagesUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/pages");
};
var getUserApprovalPageUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/user/approval");
};
var isUserPagesUrl = function(url) {
    return url && url.endsWith("/stories/user/pages");
};
var fixDevImageUrl = function(src) {
    if (isDevelopment && src && (src.startsWith("/static/") || src.startsWith("/Generator_featured images"))) {
        // in local host - change the source url to mondaystaging.com
        src = "https://mondaystaging.com" + src;
    }
    return src;
};
var addBasePathToUrl = function(src) {
    src = fixDevImageUrl(src);
    if (src && !src.startsWith("http")) {
        src = "".concat("https://monday.com").concat(src);
    }
    return src;
};
var getIntercomConversationUrl = function(appId, userId) {
    return "https://app.intercom.io/a/apps/".concat(appId, "/users/").concat(userId, "/all-conversations");
};
var getMondayStoriesBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/boards/").concat(boardId);
};
var getMondayStoriesEmbeddedBoardUrl = function(boardId) {
    return "".concat(MONDAY_STORIES_SLUG_URL, "/embedded_boards_json/").concat(boardId, "?clean-board=true&allow-edit=true");
};
var getMondayBoardUrl = function(boardId, slug) {
    return "".concat(MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug), "/boards/").concat(boardId);
};
var getSlugUseTemplateUrl = function(slug) {
    return MONDAY_STORIES_SLUG_URL.replace("mondaystories", slug) + "/stories/board_from_story";
};
var getHomeUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories");
};
var getLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/authentication/signin");
};
var getSignupUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/signup");
};
var getLandingPageWithoutAutoLoginUrl = function() {
    return "".concat(COMMUNITY_URL_PREFIX, "/stories/u_landing");
};
module.exports = {
    getTemplateUrl: getTemplateUrl,
    getTemplateUrlWithNextTemplates: getTemplateUrlWithNextTemplates,
    getTemplateEditUrl: getTemplateEditUrl,
    getUserTemplatesUrl: getUserTemplatesUrl,
    getUserApprovalPageUrl: getUserApprovalPageUrl,
    getAccountTemplatesUrl: getAccountTemplatesUrl,
    getAdminPageUrl: getAdminPageUrl,
    fixDevImageUrl: fixDevImageUrl,
    getShareNewTemplateUrl: getShareNewTemplateUrl,
    getUserPagesUrl: getUserPagesUrl,
    isUserPagesUrl: isUserPagesUrl,
    getTemplateEditSelfie: getTemplateEditSelfie,
    getTemplateEditBoardScreenshot: getTemplateEditBoardScreenshot,
    getIntercomConversationUrl: getIntercomConversationUrl,
    getMondayStoriesBoardUrl: getMondayStoriesBoardUrl,
    getMondayBoardUrl: getMondayBoardUrl,
    getMondayStoriesEmbeddedBoardUrl: getMondayStoriesEmbeddedBoardUrl,
    getSlugUseTemplateUrl: getSlugUseTemplateUrl,
    getHomeUrl: getHomeUrl,
    getLoginUrl: getLoginUrl,
    getSignupUrl: getSignupUrl,
    getLandingPageWithoutAutoLoginUrl: getLandingPageWithoutAutoLoginUrl,
    getTop5CategoryPageUrl: getTop5CategoryPageUrl,
    addBasePathToUrl: addBasePathToUrl
};


/***/ }),

/***/ 56274:
/***/ (function(module) {


var TESTING_ENV = "test";
var isDevelopment = "production" === "development";
var isTesting = "production" === TESTING_ENV;
module.exports = {
    isDevelopment: isDevelopment,
    isTesting: isTesting
};


/***/ }),

/***/ 41871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var getCookie = (__webpack_require__(47041).getCookie);
var isDevelopment = (__webpack_require__(56274).isDevelopment);
var isRunningInClient = (__webpack_require__(44566).isRunningInClient);
var AB_TEST_VARIANTS_HEADER = "x-abtest-variants";
var getHasFreeTier = (__webpack_require__(83070).getHasFreeTier);
var getHasStudentPlan = (__webpack_require__(61418).getHasStudentPlan);
var ref = __webpack_require__(13019), HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME = ref.HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME, HAS_FREE_TIER_INDICATION_COOKIE_NAME = ref.HAS_FREE_TIER_INDICATION_COOKIE_NAME;
var ref1 = __webpack_require__(54224), FORCE_PRICING = ref1.FORCE_PRICING, PREVENT_FREE_TIER_PARAM = ref1.PREVENT_FREE_TIER_PARAM;
var SYNTHETIC_TEST_COOKIE_NAME = (__webpack_require__(13019).SYNTHETIC_TEST_COOKIE_NAME);
var getBigBrainEventSentVarName = function(testName) {
    return "bb_event_sent_ab_test_".concat(testName);
};
var testEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    return !!window[eventSentVar];
};
var setTestEventSent = function(testName) {
    var eventSentVar = getBigBrainEventSentVarName(testName);
    window[eventSentVar] = true;
};
var setHotjarTestVariant = function(testName, testVariant) {
    if (!isRunningInClient) return;
    if (window && !window.hj || !testVariant) return;
    if (window.path !== "/") return; // temp specific code to record only homepage
    var tag = "".concat(testName, "-").concat(testVariant);
    window.hj("trigger", "".concat(tag));
};
// if called in the client, req and res will be undefined.
// This is ok in the case we just want to avoid sending the BigBrain event
// in synthetic tests and this is only relevant for client.
var shouldSkipEnteringTest = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var req = options.req, res = options.res;
    // Synthetic test - skip entering AB test
    return !!getCookie(SYNTHETIC_TEST_COOKIE_NAME, {
        req: req,
        res: res
    });
};
var sendAbTestEvent = function(testName, variant) {
    var extraParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (isRunningInClient() && !testEventSent(testName)) {
        var trackEvent = (__webpack_require__(95470).trackEvent);
        trackEvent(testName, _object_spread({
            ab_test: variant
        }, extraParams));
        setTestEventSent(testName);
    }
};
// can be used both in Server and Clients side render - event sent only when in client
var getAbTestVariantNew = function(allAbTests, testName) {
    var sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, sendHotjarEvent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, extraBigBrainParams = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    if (isRunningInClient() && shouldSkipEnteringTest()) return null;
    var test = allAbTests.find(function(abTest) {
        return abTest.name === testName;
    });
    if (!test) return null;
    if (sendBigBrainEvent) {
        sendAbTestEvent(testName, test.variant, extraBigBrainParams);
        if (sendHotjarEvent) setHotjarTestVariant(testName, test.variant);
    }
    return test.variant;
};
var fireEventsOnServerRedirectTests = function(allAbTests) {
// THIS FUNCTION IS USED TO SEND BIG BRAIN EVENT WHEN RUNNING SERVER REDIRECT TESTS
// CREATE AN ABTEST WITH exact_pages that include only the original and redirect page and then call:
// getAbTestVariantNew(allAbTests, TEST_NAME, true);
};
var isInTestWithNewVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.new_variation_name;
};
var isInTestWithOldVariant = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent) === abTestData.old_variation_name;
};
var isInTest = function(abTestData) {
    var abTests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], sendBigBrainEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return !!getAbTestVariantNew(abTests, abTestData.test_name, sendBigBrainEvent);
};
var getHasFreeTierByRequest = function(req) {
    if (!req) return false;
    var path = req.path;
    var freeTierForcePrevent = req.query && req.query[PREVENT_FREE_TIER_PARAM];
    var forcePricing = req.query && req.query[FORCE_PRICING];
    var hasFreeTierCookie = req.cookies[HAS_FREE_TIER_INDICATION_COOKIE_NAME];
    var hasStudentPlanCookie = req.cookies[HAS_STUDENT_PLAN_INDICATION_COOKIE_NAME];
    var hasStudentPlan = getHasStudentPlan({
        forcePricing: forcePricing,
        hasStudentPlanCookie: hasStudentPlanCookie
    });
    return getHasFreeTier({
        asPath: path,
        freeTierForcePrevent: freeTierForcePrevent,
        hasStudentPlan: hasStudentPlan,
        hasFreeTierCookie: hasFreeTierCookie
    });
};
var DEV_AB_TESTS = [
    {
        name: "crm_pricing_page_sections_test",
        variant: "new_with_crm_sections"
    },
    {
        name: "contact_sales_submit_notice_ab_test",
        variant: "new_with_submit_notice"
    },
    {
        name: "keep_region_au_ab_test",
        variant: "new_with_keep_region"
    },
    {
        name: "contact_sales_typeform_emea",
        variant: "new_with_typeform"
    },
    {
        name: "contact_sales_typeform_anz",
        variant: "new_with_typeform"
    },
    {
        name: "header_new_products_offering_more_clickable_test",
        variant: "old_header_products_offering"
    },
    {
        name: "pricing_page_sub_title_v2_ab_test",
        variant: "new_pricing_with_sub_title_v2"
    },
    {
        name: "unlimited_time_free_plan_cta_text_test",
        variant: "new_unlimited_time_cta"
    },
    {
        name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
        variant: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
    }
];
var getAbTestsFromRequest = function(req) {
    if (isDevelopment) return JSON.stringify(DEV_AB_TESTS);
    return req.headers[AB_TEST_VARIANTS_HEADER];
};
var getAllAbTestsVariantsFromRequest = function(req) {
    var abTestsHeader = req && getAbTestsFromRequest(req);
    if (abTestsHeader) {
        try {
            return JSON.parse(abTestsHeader);
        } catch (err) {
            console.error("Error Parsing AB Test Header string:", abTestsHeader, " with error: ", err);
            return [];
        }
    } else {
        return [];
    }
};
module.exports = {
    getAbTestVariantNew: getAbTestVariantNew,
    sendAbTestEvent: sendAbTestEvent,
    fireEventsOnServerRedirectTests: fireEventsOnServerRedirectTests,
    getAllAbTestsVariantsFromRequest: getAllAbTestsVariantsFromRequest,
    isInTest: isInTest,
    isInTestWithNewVariant: isInTestWithNewVariant,
    isInTestWithOldVariant: isInTestWithOldVariant,
    getHasFreeTierByRequest: getHasFreeTierByRequest,
    shouldSkipEnteringTest: shouldSkipEnteringTest
};


/***/ }),

/***/ 83070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var URL_PREFIXES = (__webpack_require__(16612).URL_PREFIXES);
var startsWith = __webpack_require__(10240);
var getHasFreeTier = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var freeTierForcePrevent = options.freeTierForcePrevent, asPath = options.asPath, hasFreeTierCookie = options.hasFreeTierCookie, hasStudentPlan = options.hasStudentPlan;
    // QS to prevent free tier
    if (freeTierForcePrevent) return false;
    // Student plan is private case of free tier
    if (hasStudentPlan) return true;
    // Free tier landing pages start with /ft/. we want to force free tier for them.
    if (asPath && startsWith(asPath, URL_PREFIXES.FREE_TIER)) return true;
    // Platform indication.
    if (hasFreeTierCookie) return hasFreeTierCookie === "true";
    return true;
};
module.exports = {
    getHasFreeTier: getHasFreeTier
};


/***/ }),

/***/ 61418:
/***/ (function(module) {


var getHasStudentPlan = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var forcePricing = options.forcePricing, hasStudentPlanCookie = options.hasStudentPlanCookie;
    // Enable us to force the student plan by query param.
    if (forcePricing === "student_plan") return true;
    // Platform indication.
    return hasStudentPlanCookie === "true";
};
module.exports = {
    getHasStudentPlan: getHasStudentPlan
};


/***/ }),

/***/ 20618:
/***/ (function(module, exports, __webpack_require__) {

// Returns the objects that leftArr contains and rightArr doesn't (i.e. leftArr - rightArr )

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var getArraysDifference = function(leftArr, rightArr) {
    if (isEmpty(leftArr)) {
        return [];
    }
    if (isEmpty(rightArr)) {
        return leftArr.slice(); // clone
    }
    var difference = leftArr.filter(function(x) {
        return rightArr.indexOf(x) == -1;
    });
    return difference;
};
// returns a random integer between 0 and max (exclusive)
var getRandomInt = function(max) {
    return Math.floor(Math.random() * Math.floor(max));
};
// shuffles array in place
var shuffleArrayInPlace = function(array) {
    for(var i = array.length - 1; i > 0; i--){
        var j = getRandomInt(i + 1);
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
};
/**
 * returns the nested object according to the key
 * i.e. obj = { outer: {inner: 3}}, key = "outer.inner" => return 3, key="other.inner" => return undefined
 * @param {Object} obj
 * @param {String} key
 */ var getNestedObject = function getNestedObject(obj, key) {
    return key.split(".").reduce(function(nested, currentKey) {
        return typeof nested == "undefined" || nested === null ? nested : nested[currentKey];
    }, obj);
};
/**
 * return true if the given object is empty (empty string / empty array / empty object / null / undefined)
 * @param {*} data
 */ var isEmpty = function(data) {
    if (typeof data == "number" || typeof data == "boolean") {
        return false;
    }
    if (typeof data == "undefined" || data === null) {
        return true;
    }
    if (typeof data.length != "undefined") {
        return data.length == 0;
    }
    for(var i in data){
        if (data.hasOwnProperty(i)) {
            return false;
        }
    }
    return true;
};
var UUID_LENGTH = 36;
var isUUID = function(str) {
    var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return !!str.match(regex);
};
var sleep = function(milliseconds) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, milliseconds);
    });
};
var isFunction = function(value) {
    return typeof value === "function";
};
var mapValuesAsync = function(obj, asyncFn) {
    var keys = Object.keys(obj);
    var promises = keys.map(function(k) {
        return asyncFn(obj[k]).then(function(newValue) {
            return {
                key: k,
                value: newValue
            };
        });
    });
    return Promise.all(promises).then(function(values) {
        var newObj = {};
        values.forEach(function(v) {
            newObj[v.key] = v.value;
        });
        return newObj;
    });
};
var newUniqueArray = function(array) {
    return _toConsumableArray(new Set(array));
};
module.exports = {
    getArraysDifference: getArraysDifference,
    getRandomInt: getRandomInt,
    isEmpty: isEmpty,
    getNestedObject: getNestedObject,
    isUUID: isUUID,
    UUID_LENGTH: UUID_LENGTH,
    sleep: sleep,
    isFunction: isFunction,
    mapValuesAsync: mapValuesAsync,
    newUniqueArray: newUniqueArray,
    shuffleArrayInPlace: shuffleArrayInPlace
};


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getHoverColor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _color_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(273);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
// Version 4.1



var pSBC = function(p, c0, c1, l) {
    var r, g, b, P, f, t, h, m = Math.round, a = typeof c1 == "string";
    if (typeof p != "number" || p < -1 || p > 1 || typeof c0 != "string" || c0[0] != "r" && c0[0] != "#" || c1 && !a) return null;
    h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBC.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBC.pSBCr(c1) : P ? {
        r: 0,
        g: 0,
        b: 0,
        a: -1
    } : {
        r: 255,
        g: 255,
        b: 255,
        a: -1
    }, p = P ? p * -1 : p, P = 1 - p;
    if (!f || !t) return null;
    if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
    else r = m(Math.pow(P * Math.pow(f.r, 2) + p * Math.pow(t.r, 2), 0.5)), g = m(Math.pow(P * Math.pow(f.g, 2) + p * Math.pow(t.g, 2), 0.5)), b = m(Math.pow(P * Math.pow(f.b, 2) + p * Math.pow(t.b, 2), 0.5));
    a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
    if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
    else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
};
pSBC.pSBCr = function(d) {
    var i = parseInt;
    var n = d.length, x = {};
    if (n > 9) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(d = d.split(","), 4), r = ref[0], g = ref[1], b = ref[2], a = ref[3];
        n = d.length;
        if (n < 3 || n > 4) return null;
        x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    } else {
        if (n == 8 || n == 6 || n < 4) return null;
        if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
        d = i(d.slice(1), 16);
        if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = Math.round((d & 255) / 0.255) / 1000;
        else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    }
    return x;
};
var getHoverColor = function(colorValue) {
    var amount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -0.3;
    // TODO: add support for hover effect on gradients
    if (colorValue === _colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[_color_consts__WEBPACK_IMPORTED_MODULE_2__.GRADIANT_WORKOS_IRIS_COLOR_NAME]) {
        return _colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[_color_consts__WEBPACK_IMPORTED_MODULE_2__.GRADIANT_WORKOS_IRIS_HOVER_COLOR_NAME];
    }
    return pSBC(amount, colorValue);
};


/***/ }),

/***/ 34955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ isAndroid; },
/* harmony export */   "f5": function() { return /* binding */ appendUrlSchemeIfNeeded; },
/* harmony export */   "pN": function() { return /* binding */ isMeta; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports isFacebook, isInstagram */
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76127);
/* harmony import */ var services_user_agent_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__);

var isAndroid = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isAndroidViewer)(userAgent);
};
var isMobile = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isMobileOrTabletViewer)(userAgent);
};
var isFacebook = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isFacebookViewer)(userAgent);
};
var isInstagram = function(userAgentParam) {
    var userAgent = userAgentParam || (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.fetchUserAgent)();
    return (0,services_user_agent_service__WEBPACK_IMPORTED_MODULE_0__.isInstagramViewer)(userAgent);
};
var isMeta = function(userAgentParam) {
    return isFacebook(userAgentParam) || isInstagram(userAgentParam);
};
var appendUrlSchemeIfNeeded = function(url) {
    var urlScheme = "";
    var urlSuffix = "";
    // https://stackoverflow.com/questions/64934340/google-sign-in-not-working-in-facebook-in-app-browser
    // force open in external browser
    if (isMeta() && isAndroid()) {
        urlScheme = "intent:https:";
        urlSuffix = "#Intent;end";
    }
    return "".concat(urlScheme).concat(url).concat(urlSuffix);
};


/***/ })

}]);